import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  Signal,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { NgbTooltip, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { IconTypes } from '@shared/v2';
import { of, switchMap, tap, timer } from 'rxjs';
import { SdvorIconComponent } from '../icon';
import { CopyCodeTooltipService, TooltipState } from './copy-code.component.service';

@Component({
  selector: 'sd-copy-code',
  imports: [NgbTooltipModule, SdvorIconComponent],
  templateUrl: './copy-code.component.html',
  styleUrls: ['./copy-code.component.scss'],
  providers: [CopyCodeTooltipService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyCodeComponent implements AfterViewInit {
  private copyCodeTooltipService = inject(CopyCodeTooltipService);
  private destroyRef = inject(DestroyRef);

  protected readonly code = input.required<string>();
  protected readonly iconTypes = IconTypes;

  @ViewChild('tooltip') tooltip!: NgbTooltip;

  get tooltipState(): Signal<TooltipState> {
    return this.copyCodeTooltipService.getTooltipState();
  }

  tooltipState$ = toObservable(this.tooltipState);

  ngAfterViewInit(): void {
    this.tooltipState$
      .pipe(
        tap((state) => {
          if (!state.show && this.tooltip) {
            this.tooltip.close();
          }
        }),
        switchMap((state) => {
          if (state.show && this.tooltip) {
            this.tooltip.open();

            return timer(2000).pipe(
              tap(() => {
                if (this.tooltip?.isOpen()) {
                  this.tooltip.close();
                  this.copyCodeTooltipService.toggleShow({ show: false, text: '' });
                }
              }),
            );
          }

          return of(null);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  onCopyCode(): void {
    navigator.clipboard.writeText(this.code());

    this.copyCodeTooltipService.toggleShow({
      show: !!this.code(),
      text: 'код скопирован',
    });
  }
}
